import EntityListContainer from './EntityListContainer'
import EntityDetail from './EntityDetail'
import FilterPanel from './FilterPanel'
import { setUsers } from './AclDataProvider/actions'
import { Detail, Domains, Functions, Spaces, Roles } from './DetailPanels'
import { User } from 'react-feather'
import { Modal, Button, Input } from 'antd'
import { ChangePassword } from 'Components'
import { useState } from 'react'
import { Globe } from 'react-feather'
import { Tag } from 'antd'
import moment from 'moment'
import ACLService from 'Services/ACL_Service'

formatDate = (date, format='YYYY-MM-DD HH:mm:ss') ->
  moment(date).format(format)

getSpaces = (user) ->
  Promise.map(await user.getProjects(), (space) ->
    getPermissions(user, space)
  )

getPermissions = (user, space) ->
  space.acl = await space.getACL()

  roles = await user.getRoles()

  space.hasRoleReadAccess = roles.map((role) ->
    space.acl.getRoleReadAccess(role)
  ).some((canRead)-> canRead)
  space.hasUserReadAccess = space.acl.getUserReadAccess(user)
  space.hasPublicReadAccess = space.acl.getPublicReadAccess()

  space.hasRoleWriteAccess = roles.map((role) ->
    space.acl.getRoleWriteAccess(role)
  ).some((canWrite)-> canWrite)
  space.hasUserWriteAccess = space.acl.getUserWriteAccess(user)
  space.hasPublicWriteAccess = space.acl.getPublicWriteAccess()

  space.hasReadAccess = space.hasRoleReadAccess or space.hasUserReadAccess or space.hasPublicReadAccess
  space.hasWriteAccess = space.hasRoleWriteAccess or space.hasUserWriteAccess or space.hasPublicWriteAccess

  space.cannotChangePermissions = space.hasRoleWriteAccess or space.hasPublicWriteAccess
  space.cannotRevoke = space.hasRoleReadAccess or space.hasPublicReadAccess

  space

setSpaceWriteAccess = (user, space, canWrite) ->
  space.acl.setUserWriteAccess(user, canWrite)
  space.acl.save()

getRoles = (user) ->
  _.filter(await user.getRoles(), (role) ->
    not role._isDomain
  )

addRole = (user, role) ->
  role.addUser(user)
  await role.save()
  role

removeRole = (user, role) ->
  role.removeUser(user)
  role.save()

getDomains = (user) ->
  _.filter(await user.getRoles(), (role) ->
    role._isDomain
  )

addDomain = (user, domain) ->
  domain.addUser(user)
  await domain.save()
  domain

removeDomain = (user, domain) ->
  domain.removeUser(user)
  domain.save()

addRole = (user, role) ->
  role.addUser(user)
  await role.save()
  role

removeRole = (user, role) ->
  role.removeUser(user)
  role.save()

getFunctionPermissions = (user, acl) ->
  roles = await user.getRoles()

  acl.hasRoleReadAccess = roles.map((role) ->
    acl.getRoleReadAccess(role)
  ).some((canRead)-> canRead)
  acl.hasRoleWriteAccess = roles.map((role) ->
    acl.getRoleWriteAccess(role)
  ).some((canWrite)-> canWrite)

  acl.hasUserReadAccess = acl.getUserReadAccess(user)
  acl.hasUserWriteAccess = acl.getUserWriteAccess(user)

  acl.hasReadAccess = acl.hasRoleReadAccess or acl.hasUserReadAccess
  acl.hasWriteAccess = acl.hasRoleWriteAccess or acl.hasUserWriteAccess

  acl.cannotChangePermissions = acl.hasRoleWriteAccess
  acl.cannotRevoke = acl.hasRoleReadAccess

  acl

getFunctions = (user) ->
  Promise.filter(await Weaver.ACL.list(), (acl) ->
    await getFunctionPermissions(user, acl)
    (acl.hasRoleReadAccess or acl.hasUserReadAccess) and ACLService.functionAclFilter(acl)
  )

addFunction = (user, acl) ->
  acl.setUserReadAccess(user, true)
  await acl.save()
  getFunctionPermissions(user, acl)

setFunctionWriteAccess = (user, acl, canWrite) ->
  acl.setUserWriteAccess(user, canWrite)
  acl.hasWriteAccess = canWrite
  await acl.save()

removeFunction = (user, acl) ->
  acl.setUserReadAccess(user, false)
  acl.setUserWriteAccess(user, false)
  acl.save()

export DetailView = EntityDetail({
  icon: 'user'
  title: (user) ->
    "#{user.firstname} #{user.lastname}"
  description: (user) -> user.email
  getItem: (id) ->
    if id is 'new'
      user = new Weaver.User('newuser', undefined, 'email@domain.com')
      user.active = true
      user.firstname = 'New'
      user.lastname = 'User'
      user.isCreating = true
      user
    else
      (await Weaver.User.list()).find((user) ->
        user.id() is id
      )
  tabs: [{
    title: 'User Detail'
    Component: Detail({
      displayName: (item) -> item.username
      fields: () -> [
        'username',
        { field: 'password', editable: 'hidden', Component: Input.Password },
        'firstname',
        'lastname',
        'email',
        'active'
      ]
      onDelete: ({ history, item }) ->
        await item.destroy()
        history.push('/acl/users')
      editActions: [
        ({ item }) ->
          [visible, setVisible] = useState(false)
          <>
            <Button onClick={-> setVisible(true) }>Change password</Button>
            <Modal
              title="Change Password"
              width={600}
              visible={visible}
              footer={null}
              destroyOnClose={true}
              onCancel={-> setVisible(false)}
            >
              <ChangePassword
                closeModal={-> setVisible(false)}
                user={item} />
            </Modal>
          </>
      ]
    })
  }, {
    title: 'Domain Access'
    Component: Domains({ getDomains, addDomain, removeDomain })
  }, {
    title: 'Space Access'
    Component: Spaces({ getSpaces, setWriteAccess: setSpaceWriteAccess })
  }, {
    title: 'Group Memberships'
    Component: Roles({ getRoles, addRole, removeRole })
  }, {
    title: 'Granted Permissions'
    Component: Functions({ getFunctions, addFunction, setWriteAccess: setFunctionWriteAccess, removeFunction })
  }]
})

filterPanelOpts = [
  { group: 1, label: 'Active', validator: ({ active }) -> active is true },
  { group: 1, label: 'Inactive', validator: ({ active }) -> active is false }
  { group: 2, label: 'Has Domains', validator: ({ domains }) -> domains.length > 0 },
  { group: 2, label: 'Domainless', validator: ({ domains }) -> domains.length is 0 }
]

export ListView = EntityListContainer({
  title: 'All users'
  singular: 'user'
  singularRoute: 'users'
  Icon: User
  init: ->
    users = await Weaver.User.list()
    users = await Promise.all(users.map((user) ->
      user.domains = await  getDomains(user)
      user
    ))
    setUsers(users)
  reducerKey: 'users'
  filterer: (str) -> (item) -> "#{ item.firstname } #{ item.lastname }".toLowerCase().indexOf(str.toLowerCase()) isnt -1
  filterPanelOpts,
  itemProps: {
    title: (item) -> "#{ item.firstname } #{ item.lastname }"
    key: (item) -> item.userId
    description: ({email, lastLogin}) ->
      <>
        { email }
        {
          if lastLogin?
            <i>{ '\n' }Last login: { formatDate(lastLogin, 'MMMM Do YYYY, h:mm a') }</i>
        }
      </>
    titleExtra: (item) ->
      <>
        {
          if item.active
            <Tag color="blue">Active</Tag>
          else
            <Tag color="red">Inactive</Tag>
        }
        {
          if item.domains.length isnt 0
            <Tag color="green"><Globe style={ {height: '10px'} }/></Tag>
        }
      </>
  },
  actions: [{
    content: -> 'Delete'
    requiresConfirmation: true
    danger: true
    fn: (item) -> item.destroy()
    accessFn: (item) -> ACLService.hasWriteAccess()
  }]
})
